<template>
  <v-container>
    <v-alert
      :type="alertType"
      transition="scale-transition"
      v-model="alertBox"
      border="left"
      dismissible
    >{{alertMsg}}</v-alert>
    <v-row justify="space-around" align="center">
      <v-col class="text-center" cols="12" sm="6" lg="3">
        <v-text-field label="Name" v-model="name"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <v-row align="center">
          <v-col class="text-right">
            <v-jsoneditor
              style="z-index: 1;"
              v-model="testJson"
              :plus="false"
              :options="{ mode: 'code', enableTransform: false }"
              :height="'250px'"
            ></v-jsoneditor>
          </v-col>
          <v-col class="text-left">
            <p>TestJson :</p>
            <vue-json-pretty :data="testJson"></vue-json-pretty>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <codeInput :code="deviceTypeAlert.function" @newCode="newCode"></codeInput>
    <v-row>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DeviceTypes.back')}}
        </v-btn>
      </v-col>

        <v-col v-if="deviceTypeAlert.name != undefined" class="text-center">
          <v-btn class="ma-2" tile outlined color="primary" @click="deleteAlert">
            <v-icon left>mdi-delete</v-icon>
            {{$t('DeviceTypes.delete')}}
          </v-btn>
        </v-col>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="save">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DeviceTypes.save')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CodeInputComponent from "./CodeInput";
import VJsoneditor from "v-jsoneditor/src/index";
import VueJsonPretty from "vue-json-pretty";

import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {
    VJsoneditor,
    VueJsonPretty,
    codeInput: CodeInputComponent
  },
  props: {
    choosenDeviceType: Object,
    deviceTypeAlert: Object,
    path: String
  },
  data() {
    return {
      name: "",
      testJson: {},
      alertType: "error",
      alertMsg: "",
      alertBox: false,
      code: ""
    };
  },
  computed: {
    readyToSave: function() {
      if (this.name != "" && this.testJson != {}) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    deleteAlert(){
      axios
        .delete(
              process.env.VUE_APP_API_ADDR +
                "/api/devicetype/" +
                this.choosenDeviceType.deviceTypeId +
                "/alert",
          {
            headers: {
              Authorization: tokenStore.getToken()
            },
            data:             {
                alerts: [
                  {
                    name: this.deviceTypeAlert.name
                  }
                ]
               
              }
          }
        )
        .then(res => {
          if (res.data.success) {
              this.$emit("saved", "Alert function removed !");
          }
        })
        .catch(err => {
          if (err) {
              this.alertType = "error";
              this.alertMsg = err.response.data.errorMessage;
              this.alertBox = true;
              window.scrollTo(0, 0);
          }
        });

    },
    newCode(value) {
      this.code = value;
    },
    save: function() {
      if (this.readyToSave) {
        if (this.path == "updateAlert") {
          axios
            .put(
              process.env.VUE_APP_API_ADDR +
                "/api/devicetype/" +
                this.choosenDeviceType.deviceTypeId +
                "/alert",
              {
                alerts: [
                  {
                    oldName: this.deviceTypeAlert.name,
                    newName: this.name,
                    testJson: this.testJson,
                    function: this.code
                  }
                ]
              },
              {
                headers: { Authorization: tokenStore.getToken() }
              }
            )
            .then(() => {
              this.$emit("saved","Alert function created !");
            })
            .catch(err => {
              this.alertType = "error";
              this.alertMsg = err.response.data.errorMessage;
              this.alertBox = true;
              window.scrollTo(0, 0);
            });
        } else if (this.path == "createAlert") {
          axios
            .post(
              process.env.VUE_APP_API_ADDR +
                "/api/devicetype/" +
                this.choosenDeviceType.deviceTypeId +
                "/alert",
              {
                alerts: [
                  {
                    name: this.name,
                    testJson: this.testJson,
                    function: this.code
                  }
                ]
              },
              {
                headers: { Authorization: tokenStore.getToken() }
              }
            )
            .then(() => {
              this.$emit("saved","Alert function updated !");
            })
            .catch(err => {
              this.alertType = "error";
              this.alertMsg = err.response.data.errorMessage;
              this.alertBox = true;
              window.scrollTo(0, 0);
            });
        }
      } else {
        this.alertType = "error";
        this.alertMsg = this.$t("Complete correctly the form");
        this.alertBox = true;
        window.scrollTo(0, 0);
      }
    }
  },
  beforeMount() {
    if (this.path == "updateAlert") {
      this.name = this.deviceTypeAlert.name;
      this.testJson = this.deviceTypeAlert.testJson;
    }
  }
};
</script>